module.exports = __webpack_public_path__ + "img/epay-logos.ddf39e56.png";